<template>
  <!-- 对话框 -->
  <el-dialog title="推广审核" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box" style="max-height: 70vh; overflow-y: auto;">
      <el-form label-width="80px">


        <div style="display: flex; justify-content: space-around;" v-if="determine_data!=null">

          <el-image :preview-src-list="srcList" v-if="img_url.img_one" :src="img_url.img_one" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


          <el-image :preview-src-list="srcList" v-if="img_url.img_two" :src="img_url.img_two" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


          <el-image :preview-src-list="srcList" v-if="img_url.img_three" :src="img_url.img_three" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;"></el-image>

        </div>

        <div style="display: flex; justify-content: space-around;" v-if="determine_data!=null">

          <el-image :preview-src-list="srcList" v-if="img_url.img_four" :src="img_url.img_four" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


          <el-image :preview-src-list="srcList" v-if="img_url.img_fives" :src="img_url.img_fives" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


          <el-image :preview-src-list="srcList" v-if="img_url.img_six" :src="img_url.img_six" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;"></el-image>

        </div>

        <div style="display: flex; justify-content: space-around;" v-if="determine_data!=null">

          <el-image :preview-src-list="srcList" v-if="img_url.img_seven" :src="img_url.img_seven" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


          <el-image :preview-src-list="srcList" v-if="img_url.img_eight" :src="img_url.img_eight" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;">
          </el-image>


          <el-image :preview-src-list="srcList" v-if="img_url.img_nine" :src="img_url.img_nine" class="avatar"
            style="border: 1px solid #ccc; border-radius: 5px;"></el-image>

        </div>




        <el-form-item label="推广审核:" label-width='120px' v-if="determine_data!=null" style="margin-top: 20px;">

          <p v-if="!submit_btn_show">已通过</p>

          <el-radio-group v-model="submit_data.verify_status" v-else>
            <el-radio-button label="1">通过</el-radio-button>
            <el-radio-button label="2">拒绝</el-radio-button>
          </el-radio-group>

        </el-form-item>




        <el-form-item label="系统备注:" label-width='120px' v-if="determine_data!=null">
          <el-input type="textarea" autosize v-model="submit_data.verify_remarks"
            :placeholder="submit_rules.verify_remarks.placeholder">
          </el-input>
        </el-form-item>

        <div v-if="determine_data == null" style="text-align: center;margin-bottom: 20px;">无推广审核信息,不能进行审核</div>

      </el-form>

      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="determineonSubmit" v-if="submit_btn_show">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;
        _this.submit_data.driver_promote_code = _this.data;


        this.$post(
            "/promote/getDriverPromoteDetails", {
              driver_promote_code: this.data
            }
          )
          .then(res => {

            // 在submit_data对象中赋值driver_promote_code
            this.submit_data.driver_promote_code = this.data;

            // 判断返回的data中是否有值
            if (res.data == null) {

              this.determine_data = null;

            } else {

              _this.submit_data.verify_status = res.data.verify_status.val;
              _this.submit_data.verify_remarks = res.data.verify_remarks;

              this.determine_data = {};

              this.verify_status = res.data.verify_status;
              this.verify_remarks = res.data.verify_remarks;


              // 图片路径
              this.img_url.img_one = res.data.img_one.url;
              this.img_url.img_two = res.data.img_two.url;
              this.img_url.img_three = res.data.img_three.url;
              this.img_url.img_four = res.data.img_four.url;
              this.img_url.img_fives = res.data.img_fives.url;
              this.img_url.img_six = res.data.img_six.url;
              this.img_url.img_seven = res.data.img_seven.url;
              this.img_url.img_eight = res.data.img_eight.url;
              this.img_url.img_nine = res.data.img_nine.url;

              this.srcList.length = 0;
              this.srcList.push(this.img_url.img_one);
              this.srcList.push(this.img_url.img_two);
              this.srcList.push(this.img_url.img_three);
              this.srcList.push(this.img_url.img_four);
              this.srcList.push(this.img_url.img_fives);
              this.srcList.push(this.img_url.img_six);
              this.srcList.push(this.img_url.img_seven);
              this.srcList.push(this.img_url.img_eight);
              this.srcList.push(this.img_url.img_nine);

              if (_this.submit_data.verify_status != '0') {

                _this.submit_btn_show = false;

              } else {

                _this.submit_btn_show = true;

              }

            }

          })

      },

    },
    data() {
      return {

        show: false,
        verify_status: '',
        verify_remarks: '',
        srcList: [],

        submit_btn_show: true,

        //上传图片
        img_url: {
          img_one: '',
          img_two: '',
          img_three: '',
          img_four: '',
          img_fives: '',
          img_six: '',
          img_seven: '',
          img_eight: '',
          img_nine: ''
        },

        determine_data: {},

        // 表单数据
        submit_data: {
          driver_promote_code: '',
          verify_status: '',
          verify_remarks: ''
        },

        submit_rules: {
          verify_status: {
            placeholder: '审核判定',
            rules: {
              required: true,
              message: '未选择审核判定状态',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          verify_remarks: {
            placeholder: '审核原因',
            rules: {
              required: true,
              message: '角色名100个汉字以下',
              regulation: 'elt_str',
              rulesData: 200
            }
          },

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;

        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }

      },

      // 提交按钮
      determineonSubmit() {

        _this.$post(
            '/promote/executeDriverPromoteSubmit',
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {
            _this.$message.success(res.msg)
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();

          }).catch((err) => {

          })

      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;

  }

  .el-form-item__content {
    position: relative;
  }
</style>